import { toObjectMap } from "@@/utilities/dictionary";
import type { Except } from "type-fest";
import type { EntityState } from "../entity-status";
import { paymentProviders } from "../payments/payment-providers";

const externalReferenceProviders = [
    ...paymentProviders,
    "ZETTLE",
    "CHANNEX",
    "STRIPE_ACCOMMODATION",
] as const;
type ExternalReferenceProvider = (typeof externalReferenceProviders)[number];
const externalReferenceProvidersMap = toObjectMap<ExternalReferenceProvider>([
    ...externalReferenceProviders,
]);

type ExternalReference = {
    _id: string;
    _type: "EXTERNAL_REFERENCE";
    _status: EntityState;
    externalReferenceProvider: ExternalReferenceProvider;
    externalId: string;
    ownerId: string;
    description?: string;
};

const externalReferenceFactory = (
    params: Except<ExternalReference, "_id" | "_type" | "_status">,
    initialStatus: EntityState = "ACTIVE",
): ExternalReference => {
    if (!params.externalId || !params.ownerId)
        throw new Error("External reference creation parameters incomplete");
    return {
        ...params,
        _id: `${params.externalId}${params.ownerId}`,
        _type: "EXTERNAL_REFERENCE",
        _status: initialStatus,
    };
};

export {
    externalReferenceFactory,
    externalReferenceProviders,
    externalReferenceProvidersMap,
};
export type { ExternalReference, ExternalReferenceProvider };
